<div class="relative group col-span-3 lg:col-span-1 h-full" (click)="onContainerClick()">

  <div>
    @if (!imageLoadFailed) {
      <img class="p-1 min-h-[400px] max-h-[400px] min-w-[400px] h-full w-full
              object-cover transition-opacity duration-300" alt="Event Image"
           [src]="this.displayEventImage()"
           (error)="onImageError()"/>

      <!-- Overlay (ligeiramente escuro, não totalmente preto) -->
      <div
        class="absolute inset-0 bg-gray-900/70 opacity-0 min-h-[400px] max-h-[400px] min-w-[400px] h-full w-full transition-opacity duration-300
                group-hover:opacity-50">

        <div
          class="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <i class="pi pi-eye text-white text-9xl"></i>
        </div>

      </div>
    } @else {
      <div
        class="flex flex-col items-center justify-center p-8 min-h-[400px] max-h-[400px] min-w-[400px] w-full bg-slate-100 border border-slate-200 rounded text-slate-500">
        <i class="pi pi-image text-7xl mb-3 opacity-60"></i>
        <span class="text-sm">Imagem indisponível</span>
      </div>
    }

  </div>

</div>
